module.exports = __webpack_public_path__ + "img/house1.3a932178.png";